/* drl-coupon — egy koppintásos kupon a termékoldalon.
   docs/sections/main-product/README.md · snippets/drl-coupon.liquid

   AZ IGAZSÁG A KOSÁR. A /cart.js discount_codes mezője (nem dokumentált,
   mérve 2026-10-05) üres kosáron is megőrzi a kódot, applicable:false-szal;
   betöltéskor ebből áll vissza az állapot. A /cart/update.js discount
   paramétere a TELJES listát cseréli (a BOGOS is ezt használja), ezért a
   meglévő kódokat megtartjuk. Előtte a /discount/<kód> is lefut (a /cart.js-re
   irányítva): ez a pénztár által olvasott sütit is beállítja. Hálózati vagy
   szerverhibánál a /discount/ link viszi a kódot, munkamenetenként egyszer. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSON_H = { Accept: 'application/json' };

  function entry(cart, code) {
    return (cart && cart.discount_codes || []).filter(function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); })[0] || null;
  }
  function has(cart, code) { return !!entry(cart, code); }

  // A Shopify BÁRMILYEN szöveget a kosáron tart kódként, a nem létezőt is
  // (applicable:false). Üres kosárnál ez nem mond semmit, ezért ott a jelenlét
  // elég. De ha a kosárban már van olyan csomag, amire a kupon szól, és a kód
  // mégsem alkalmazható, akkor a kód nem él (nincs létrehozva, más variánsra
  // szól, lejárt, vagy a vevő nem jogosult): ilyenkor nem mondjuk aktívnak.
  function evaluate(ctx, cart) {
    var d = entry(cart, ctx.code);
    if (!d) return 'absent';
    if (d.applicable) return 'on';
    var eligible = (cart.items || []).some(function (i) { var r = ctx.map[String(i.variant_id)]; return r && r.ok; });
    return eligible ? 'invalid' : 'on';
  }

  // A jegyek felső sora 390-en kb. 170 px: oda a rövid változat fér (mérve, a hosszú „…”-ra vágódott).
  var MSG_INVALID = 'A kupon ehhez a kosárhoz nem érvényes', MSG_SHORT = 'A kosárhoz nem érvényes';
  function showInvalid(ctx, on) {
    ctx.scope.querySelectorAll('.drl-coupon__lede, .drl-coupon__eye.drl-cp-base').forEach(function (el) {
      if (el.dataset.drlOrig === undefined) el.dataset.drlOrig = el.textContent;
      el.textContent = on ? (el.classList.contains('drl-coupon__lede') ? MSG_INVALID + ' · ' : MSG_SHORT) : el.dataset.drlOrig;
    });
    // A promó-sor gombja (drl-promo-pdp) a saját rövid feliratát hozza.
    ctx.scope.querySelectorAll('[data-drl-cp-msg]').forEach(function (el) {
      if (el.dataset.drlOrig === undefined) el.dataset.drlOrig = el.textContent;
      el.textContent = on ? el.getAttribute('data-drl-cp-msg') : el.dataset.drlOrig;
    });
    root(ctx).classList.toggle('drl-coupon--invalid', on);
  }
  // A gyökér újrarenderelhető (a Dawn variánsváltáskor cseréli az ár dobozát,
  // amelyben a promó-sor állhat), ezért mindig a scope-ban keressük újra.
  function root(ctx) { return ctx.scope.querySelector('[data-drl-coupon]') || ctx.el; }
  function refreshDrawer() { try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch (e) {} }
  // A /discount/ hívás csak a pénztár sütijéért fut; ha elhasalt, ugyanazt a sütit
  // (discount_code; path=/; SameSite=Lax, mérve) itt tesszük fel.
  function ensureCookie(code) {
    if (document.cookie.indexOf('discount_code=' + encodeURIComponent(code)) === -1) document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/; SameSite=Lax';
  }
  function apply(ctx, cart, opts) {
    var st = evaluate(ctx, cart);
    if (st === 'on') { showInvalid(ctx, false); setOn(ctx, opts.fromPill, opts.announce); }
    else { setOff(ctx); showInvalid(ctx, st === 'invalid'); }
    return st;
  }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: JSON_H }).then(function (r) { return r.json(); }); }

  function selectedId(scope) {
    // Ugyanaz a mező, amit a drl-offer-options.js ír; a részletfizetési űrlap
    // saját input[name="id"]-je előbb áll a DOM-ban, és elavult lehet.
    var input = scope.querySelector('input[name="id"].product-variant-id') ||
      scope.querySelector('product-form form input[name="id"]') || scope.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }

  // A megspórolt forint a kiválasztott csomagon; ha arra nem jár, az első csomagé.
  function updateSave(ctx) {
    var row = ctx.map[selectedId(ctx.scope)], text;
    var first = Object.keys(ctx.map).map(function (k) { return ctx.map[k]; }).filter(function (r) { return r.ok; })[0];
    if (row && row.ok) text = '−' + row.save + ' a pénztárnál';
    else text = first ? '−' + first.save + ' az első csomagon' : '';
    ctx.scope.querySelectorAll('[data-drl-cp-save]').forEach(function (el) { el.textContent = text; });
  }

  // Az értékelés sora nem törhet: lépcsőzetes rövidítés a tényleges szélesség szerint.
  function fitRate(ctx) {
    var pill = ctx.scope.querySelector('[data-drl-coupon-pill]'), row = pill && pill.closest('.rating-wrapper');
    if (!row) return;
    row.classList.remove('drl-rate--fit1', 'drl-rate--fit2', 'drl-rate--fit3');
    for (var step = 1; step <= 3; step++) {
      if (pill.getBoundingClientRect().right <= row.getBoundingClientRect().right + 0.5) return;
      row.classList.add('drl-rate--fit' + step);
    }
  }

  function setOn(ctx, fromPill, announce) {
    ctx.scope.setAttribute('data-drl-coupon-state', 'on');
    ctx.scope.querySelectorAll('[data-drl-coupon-activate]').forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
    var pillBtn = ctx.scope.querySelector('.drl-coupon-pill__btn');
    if (pillBtn) pillBtn.setAttribute('aria-label', 'Kupon aktiválva: ' + ctx.code);
    updateSave(ctx);
    fitRate(ctx);
    var live = root(ctx).querySelector('[data-drl-cp-live]');
    var save = ctx.scope.querySelector('[data-drl-cp-save]');
    var saveText = save ? save.textContent : '';
    if (announce && live) live.textContent = 'Kupon aktiválva: ' + ctx.code + '. ' + (saveText ? saveText + ' vonódik le.' : 'A kedvezmény a pénztárnál vonódik le.');
    var toast = fromPill && ctx.scope.querySelector('.drl-coupon-pill__toast');
    if (toast) { toast.hidden = false; clearTimeout(ctx.toastT); ctx.toastT = setTimeout(function () { toast.hidden = true; }, 4500); }
  }

  function setOff(ctx) {
    if (ctx.scope.getAttribute('data-drl-coupon-state') !== 'on') return;
    ctx.scope.removeAttribute('data-drl-coupon-state');
    ctx.scope.querySelectorAll('[data-drl-coupon-activate]').forEach(function (b) { b.removeAttribute('aria-disabled'); });
    fitRate(ctx);
  }

  function activate(ctx, btn) {
    if (ctx.busy || ctx.scope.getAttribute('data-drl-coupon-state') === 'on') return;
    ctx.busy = true; ctx.gen++;
    ctx.scope.classList.add('drl-coupon-busy');
    var done = function () { ctx.busy = false; ctx.scope.classList.remove('drl-coupon-busy'); };
    var fallback = function () {
      try { if (sessionStorage.getItem('drl-coupon-tried') === ctx.code) return done(); sessionStorage.setItem('drl-coupon-tried', ctx.code); } catch (e) {}
      window.location.href = ROOT + 'discount/' + encodeURIComponent(ctx.code) +
        '?redirect=' + encodeURIComponent(location.pathname + location.search);
    };
    var codes;
    getCart()
      .then(function (cart) {
        codes = (cart.discount_codes || []).map(function (d) { return d.code; })
          .filter(function (c) { return String(c).toLowerCase() !== ctx.code.toLowerCase(); });
        codes.push(ctx.code);
        return fetch(ROOT + 'discount/' + encodeURIComponent(ctx.code) + '?redirect=' + encodeURIComponent(ROOT + 'cart.js'),
          { headers: JSON_H }).catch(function () {});
      })
      .then(function () {
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (cart) {
        done();
        refreshDrawer();
        if (!has(cart, ctx.code)) { console.warn('drl-coupon: a kód nem került a kosárra', ctx.code); return; }
        ensureCookie(ctx.code);
        var st = apply(ctx, cart, { fromPill: !!btn.closest('[data-drl-coupon-pill]'), announce: true });
        if (st === 'invalid') {
          var live = root(ctx).querySelector('[data-drl-cp-live]');
          if (live) live.textContent = MSG_INVALID + '.';
          console.warn('drl-coupon: a kód a kosáron van, de nem alkalmazható', ctx.code);
          return;
        }
        document.dispatchEvent(new CustomEvent('drl:coupon:applied', { detail: { code: ctx.code, cart: cart } }));
      }, fallback);
  }

  function init(el) {
    if (el.__drlCoupon) return;
    var scope = el.closest('.product__info-container');
    var mapEl = el.querySelector('[data-drl-coupon-map]');
    if (!scope || !mapEl) return;
    var ctx = { el: el, scope: scope, code: el.getAttribute('data-code') || '', map: {}, gen: 0 };
    try { ctx.map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (!ctx.code) return;
    el.__drlCoupon = ctx;

    // Delegálva: az újrarenderelt gomb (promó-sor az ár dobozában) is él.
    scope.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-drl-coupon-activate]');
      if (!btn || !scope.contains(btn)) return;
      e.preventDefault();
      activate(ctx, btn);
    });
    // A változás egyetlen igazsága a rejtett input[name="id"] (drl-offer-options.js).
    scope.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') updateSave(ctx);
    });
    updateSave(ctx);
    fitRate(ctx);
    // A betűcsere a pill és a számláló szélességét változtatja: ezeket is figyeljük.
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(function () { fitRate(ctx); });
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { fitRate(ctx); });
    }
    if (window.ResizeObserver) {
      var raf = 0, ro = new ResizeObserver(function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { fitRate(ctx); }); });
      ro.observe(scope);
      scope.querySelectorAll('.drl-coupon-pill, .rating-count').forEach(function (n) { ro.observe(n); });
    }

    // Betöltéskor, visszalépéskor és kosárba tétel után a kosár dönt, mindkét irányban.
    // Generáció: ha a válasz megérkezéséig koppintás történt, a régi kosár-kép
    // nem írhatja felül az aktiválást (Astra-verifikáció, 2026-10-05).
    var check = function () {
      var g = ctx.gen;
      getCart().then(function (cart) { if (!ctx.busy && g === ctx.gen) apply(ctx, cart, { fromPill: false, announce: false }); }).catch(function () {});
    };
    check();
    window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
    scope.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) setTimeout(check, 2500);
    }, true);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') check(); });
  }

  function initAll(root) { (root || document).querySelectorAll('[data-drl-coupon]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
